/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import classNames from 'classnames';

import { Typography2 } from '@coursera/cds-core';

const styles = {
  root: css`
    display: flex;
    gap: var(--cds-spacing-100);
  `,
  senderName: css`
    color: var(--cds-color-grey-950);
    font-weight: 600;
    -webkit-line-clamp: 1;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    max-height: 22px;
  `,
};

type Props = {
  senderName: string;
  senderAvatar: React.ReactNode;
  className?: string;
};

/**
 * Renders header information for a chat message such as sender name and avatar
 */
export const ChatMessageHeader = (props: Props): React.ReactElement => {
  const { senderName, senderAvatar, className = '' } = props;
  return (
    <div className={classNames('chat-message-header', className)} css={styles.root}>
      {senderAvatar}
      <Typography2 component="h4" variant="subtitleMedium" css={styles.senderName}>
        {senderName}
      </Typography2>
    </div>
  );
};

export default ChatMessageHeader;
